import type { IncomingMessage, ServerResponse } from 'http'
import type { AccessTokenRequest, GetSession } from '@auth0/nextjs-auth0'
import { getAuth0Server } from './auth0/auth0.server'
import { getMembershipIdFromSub, UNAUTHENTICATED_USER_ID } from '../utils'
import { Auth0B2CException, logAuth0Error } from './error'

export const getSession = async (
  req: IncomingMessage,
  res: ServerResponse
): ReturnType<GetSession> => {
  try {
    return getAuth0Server(req).getSession(req, res)
  } catch (error) {
    if (error instanceof Error) {
      const authError = new Auth0B2CException(error, 'REQUEST_UNAUTHORIZED')
      logAuth0Error('Failed fetching auth session', authError, req, res)
      throw authError
    }
    throw error
  }
}

export const getAccessToken = (
  req: IncomingMessage,
  res: ServerResponse,
  opt?: AccessTokenRequest
) => {
  try {
    return getAuth0Server(req).getAccessToken(req, res, { ...opt })
  } catch (error) {
    if (error instanceof Error) {
      const authError = new Auth0B2CException(error, 'REQUEST_UNAUTHORIZED')
      logAuth0Error('Failed fetching access token', authError, req, res)
      throw authError
    }
    throw error
  }
}

export const getUserId = async (req: IncomingMessage, res: ServerResponse) => {
  const session = await getSession(req, res)

  if (!session?.user) {
    return UNAUTHENTICATED_USER_ID
  }

  const userSub = session.user.sub

  return getMembershipIdFromSub(userSub)
}
